const UnpinIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_4638_330943)">
      <line
        x1="2.41421"
        y1="4.41418"
        x2="19"
        y2="21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8.58582V9C8 10.38 7.07001 11.54 5.79999 11.89C5.34 12.02 5 12.4 5 12.87V13C5 13.55 5.45001 14 6 14H10.98L11 21C11 21.55 11.45 22 12 22C12.55 22 13 21.55 13 21L12.98 14H13.4142L8 8.58582ZM16.2426 14H18C18.55 14 19 13.55 19 13V12.87C19 12.4 18.66 12.02 18.2 11.89C16.93 11.54 16 10.38 16 9V4H17C17.55 4 18 3.55005 18 3C18 2.44995 17.55 2 17 2H7C6.45001 2 6 2.44995 6 3C6 3.55005 6.45001 4 7 4H8V5.75732L16.2426 14Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4638_330943">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default UnpinIcon
